/**
 * Gets the leaderboard from redux
 * @param {Object} state
 * @returns Leaderboard | undefined
 */
export const getLeaderboard = (state) =>
  state?.tourGamesLeaderboard?.leaderboard;
